import { assetUrl } from '../lib/api';
import { initialsFromName } from '../lib/people';

/**
 * A person. Four screens draw the same disc — the directory, a match, a profile and a presenter row
 * — so the photograph is loaded in one place and every one of them gets it at once.
 *
 * Initials are not a fallback that failed; they are what most of the list looks like until the week
 * of the event, and they carry the same weight as a face at 44 pixels. Decorative either way: the
 * name is always beside it, and a screen reader that read "M L" before "Maria Lopez" would only be
 * repeating itself.
 */
export function Avatar({
  name,
  photoAssetId,
  size = 'row',
}: {
  name: string;
  photoAssetId?: string | null;
  size?: 'row' | 'profile';
}) {
  const scale =
    size === 'profile' ? 'size-20 text-stat font-semibold' : 'size-11 text-subtitle font-bold';
  const src = assetUrl(photoAssetId);

  if (src) {
    return (
      <img
        src={src}
        alt=""
        aria-hidden="true"
        // Stored square already, so `cover` only has to survive a browser rounding the box.
        className={`shrink-0 rounded-full bg-sand-3 object-cover ${scale}`}
        loading="lazy"
        decoding="async"
      />
    );
  }

  return (
    <span
      className={`flex shrink-0 items-center justify-center rounded-full bg-sand-3 text-ink-2 ${scale}`}
      aria-hidden="true"
    >
      {initialsFromName(name)}
    </span>
  );
}
